module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_16.771b1b55.jpg";